<template>
  <dialogBar @on-close="close" v-if="config.show" :dialog-width="config.width">
    <div slot="header">{{ config.title }}</div>
    <div class="dialog_publish_main" slot="main">
      <el-form ref="form" :model="config.data" :rules="rules" label-width="110px">
        <el-form-item label="二级蔬菜类型" prop="vegetableTypeName">
          <el-input
            size="mini"
            v-model="config.data.vegetableSecondTypeName"
            placeholder="请输入二级绿通蔬菜类型"
          ></el-input>
        </el-form-item>
        <el-form-item label="绿疏类型" prop="vegetableTypeID">
          <el-select
            v-model="config.data.vegetableTypeID"
            filterable
            reserve-keyword
            size="mini"
            placeholder="请选绿疏类型"
          >
            <el-option
              v-for="item in VegetableTypeList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            class="textarea"
            placeholder="请输入备注"
            v-model="config.data.memo"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="info" size="mini" @click="close(false)">取消</el-button>
      <el-button type="primary" size="mini" @click="onSubmit('form')">确认</el-button>
    </div>
  </dialogBar>
</template>
<script>
import dialogBar from "../../../components/dialog/comment/dialogBar";
import { Message } from "element-ui";
export default {
  components: {
    dialogBar: dialogBar,
  },
  props: {
    config: {
      type: Object,
      default: {
        show: false,
        width: 800,
        title: "绿通二级蔬菜类型管理",
        data: {},
      },
    },
  },
  data() {
    return {
      VegetableTypeList: [],
      rules: {
        vegetableSecondTypeName: [
          { required: true, message: "请输入二级绿通蔬菜类型", trigger: "blur" },
        ],
        vegetableTypeID: [
          { required: true, message: "请选择绿蔬类型", trigger: "change" },
        ],
      },
    };
  },
  watch: {},
  async mounted() {
    await this.VegetableType();
  },
  methods: {
    close(result) {
      this.config.show = false;
      if (result) this.$emit("close");
    },
    onSubmit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          switch (this.config.type) {
            case 0:
              await this.$http.post("/api/VegetableSecondType/add", this.config.data);
              break;
            case 1:
              await this.$http.post("/api/VegetableSecondType/update", this.config.data);
              break;
          }
          this.close(true);
          Message.success({ showClose: true, message: "保存成功！" });
        }
      });
    },
    async VegetableType() {
      this.VegetableTypeList = await this.$http.post(
        "/api/common/LoadVegetableTypeList",
        {}
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog_publish_main {
  padding-bottom: 10px;
}
.el-select,
.el-input,
.el-textarea {
  width: 300px;
}
/deep/ .el-textarea__inner {
  font-size: 12px;
  font-family: "微软雅黑" !important;
}
</style>
